module.exports = __webpack_public_path__ + "img/Asset-209-100.d0b9846b.jpg";